import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleLoginService {

  private clientId = environment.google.clientId;

  constructor(private ngZone: NgZone) {}

  login(): Observable<string> {
    const subject = new Subject<string>();
    const client = google.accounts.oauth2.initTokenClient({
      client_id: this.clientId,
      scope: 'email profile openid',
      callback: (response: any) => {
        if (response && response.access_token) {
          this.ngZone.run(() => {
            subject.next(response.access_token);
            subject.complete();
          });
        } else {
          this.ngZone.run(() => {
            subject.error(new Error('Google login window closed or cancelled.'));
          });
        }
      },
      error_callback: (err: any) => {
        this.ngZone.run(() => subject.error(err));
      }
    });

    client.requestAccessToken();
    return subject.asObservable();
  }
}
